<script lang="ts" setup>
  import { toRefs } from 'vue'

  import ItemEffortEntry from '@/components/activity-feed/ItemEffortEntry.vue'
  import ItemTag from '@/components/activity-feed/ItemTag.vue'
  import ItemComment from '@/components/activity-feed/ItemComment.vue'
  import ItemUnsupported from '@/components/activity-feed/ItemUnsupported.vue'
  import ItemAssignment from '@/components/activity-feed/ItemAssignment.vue'
  import type { ResolvedActivity } from '@/stores'

  interface Props {
    activity: ResolvedActivity
    first: boolean
  }

  const props = defineProps<Props>()
  const { activity, first } = toRefs(props)
</script>

<template>
  <li>
    <div class="relative pb-8">
      <span
        v-if="first"
        aria-hidden="true"
        class="absolute left-5 top-5 -ml-px h-full w-0.5 bg-gray-200" />

      <ItemComment
        v-if="activity.activity.type === 'comment'"
        :activity-item="activity" />
      <ItemAssignment
        v-else-if="activity.activity.type === 'assignment'"
        :activity-item="activity" />

      <ItemTag
        v-else-if="activity.activity.type === 'tags'"
        :activity-item="activity" />

      <ItemEffortEntry
        v-else-if="activity.activity.type === 'effort-entry'"
        :activity-item="activity" />

      <ItemUnsupported
        v-else
        :activity-item="activity" />
    </div>
  </li>
</template>

<style scoped></style>
